const FORGOT_PASSWORD_PATH = "/forgot-password";
const HOME_PATH = "/";
const MENUS_PATH = "/menus";
const ORDER_PATH = "/order";
const ORDER_SUCCESS_PATH = "/order-success";
const ORDER_LIST_PATH = "/order-list";
const ORDER_DETAIL_PATH = "/order-detail";
const SHOPPING_CART_PATH = "/shopping-cart";
const PRIVACY_POLICY_PATH = "/privacy-policy";
const TERMS_AND_CONDITIONS_PATH = "/terms-and-conditions";
const REGISTRATION_PATH = "/registration";
const AUTH_ACTION_PATH = "/auth-action";
const PROFILE_PATH = "/profile";
const LOGIN_PATH = "/login";

export {
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  MENUS_PATH,
  ORDER_PATH,
  ORDER_SUCCESS_PATH,
  ORDER_LIST_PATH,
  ORDER_DETAIL_PATH,
  SHOPPING_CART_PATH,
  PRIVACY_POLICY_PATH,
  TERMS_AND_CONDITIONS_PATH,
  REGISTRATION_PATH,
  AUTH_ACTION_PATH,
  PROFILE_PATH,
  LOGIN_PATH,
};
